<template>
  <div class="py-4">
    <LoadingJoinnus v-if="showLoadingJoinnus"></LoadingJoinnus>

    <nav class="categories" v-show="step === 1">
      <ul>
        <li
          v-for="item in categories"
          :key="item.id"
          @click="onSelectCategory(item.id)"
          :style="selectCategory == item.id ? 'font-weight: bold;' : ''"
        >
          {{ item.name }}
        </li>
      </ul>
    </nav>
    <div v-if="accessCode" class="d-none">
      <img
        width="120"
        :src="
          'https://qr.joinnus.com/qr.png?size=140&body=https://www.joinnus.com/comprobante-de-pago/' +
          accessCode
        "
        alt="qr"
        style="display: inline-block"
      />
    </div>
    <div v-if="step === 4 && dataPrint.voucher" id="section-to-print">
      <Voucher :voucher="dataPrint.voucher" :meta="dataPrint.meta" :showqr="1" :taxTotal="taxTotal" />
    </div>
    <div></div>
    <div class="container">
      <SearchUser
        v-show="step === 1"
        :isIntimo="isIntimo"
        :profileIntimo="profileIntimo"
        @submit="validateUserIntimo($event)"
        placeholder="Ingrese DNI del cliente"
      />
      <SearchForm
        v-show="step === 1"
        @submit="searchSubmit($event)"
        placeholder="Nombre ó SKU del producto"
      />
      <Loader v-show="loading"></Loader>
      <div v-show="!loading">
        <!-- step 1:  lista productos -->
        <div v-show="step === 1">
          <h3 v-if="!products.length">Sin resultados.</h3>
          <div v-else>
            <ProductsList
              :products="searchProducts"
              :isIntimo="isIntimo"
              @getProducts="getProducts"
              @isDeliveryProcess="isDeliveryProcess"
            />
          </div>
        </div>
        <!-- step 2:  carrito productos -->
        <div v-if="step === 2">
          <div class="d-flex justify-content-between align-items-center">
            <h2>Carrito de compras</h2>
            <div>
              <form v-if="!coupon.code" @submit.prevent="verifyCoupon()">
                <div class="input-group">
                  <input
                    v-model="couponCode"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': couponError }"
                    placeholder="Código de cupón"
                  />
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary" type="submit">Validar</button>
                  </div>
                </div>
              </form>
              <span v-else class="btn btn-primary">
                {{ discountText }}
                <button @click="removeCoupon()" class="close ml-3">&times;</button>
              </span>
            </div>
          </div>
          <CardProfile v-if="isIntimo" :profile="profileIntimo" />
          <CartProducts :isIntimo="isIntimo"></CartProducts>
          <div class="row justify-content-between">
            <div class="col product__bottom">
              <button @click="goStep(1)" class="btn btn-secondary btn-lg" type="button">
                Seguir comprando
              </button>
            </div>
            <div v-if="cartMeta.totalProducts" class="col-auto product__bottom">
              <button @click="goStep(5)" class="btn btn-action btn-lg" type="button">
                Siguiente
              </button>
            </div>
          </div>
        </div>
        <div v-if="step === 5">
          <button @click="goStep(2)" class="btn btn-outline-secondary btn-sm mr-4 mb-3">
            Atrás
          </button>
          <UserDataBuyEvents
            :profileIntimo="profileIntimo"
            ref="formUserData"
            @submit="registerDataUser($event)"
          />
        </div>
        <div v-if="step === 3">
          <div class="row justify-content-center">
            <div class="col-12 col-lg-10">
              <FormPay
                @on-pay="onPay($event)"
                :couponFree="couponFree"
                :transaction="transaction"
                :user="user"
                :saleType="saleType"
              >
                <button @click="goStep(5)" class="btn btn-outline-secondary btn-sm mr-4">
                  Atrás
                </button>
              </FormPay>
            </div>
          </div>
        </div>
        <div v-if="step === 4">
          <div class="row justify-content-center">
            <div class="col-12 col-lg-9 col-xl-8">
              <div class="card">
                <div class="card-body py-5">
                  <h3 class="text-center">Registro de compra exitoso.</h3>
                  <hr />
                  <h5 class="text-center" v-if="dataPrint.voucher">
                    N° de Boleta: <b>{{ dataPrint.voucher.id }}</b>
                  </h5>
                  <br />
                  <p class="text-center" v-if="dataPrint.voucher">
                    <button @click="print()" type="button" class="btn btn-action btn-lg">
                      Imprimir boleta
                    </button>
                  </p>
                  <br />
                  <p class="text-center">
                    <button @click="modalConfirmNew = true" type="button" class="btn btn-primary">
                      Nueva venta
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <b-modal
            v-model="modalConfirmNew"
            hide-header
            cancel-title="Cerrar"
            ok-title="Confirmar"
            ok-variant="action btn-lg ml-3"
            @ok="newShop()"
          >
            <div class="text-center">
              <p class="lead p-4">¿Estás segur@ que deseas salir de la pantalla de impresión?</p>
            </div>
          </b-modal>
        </div>
        <div v-if="cartMeta.totalProducts" @click="goStep(2)" class="cart-float shadow">
          <i class="material-icons">shopping_cart</i>
          <span class="shadow">{{ cartMeta.totalProducts }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api';

const docTypes = ['DNI', 'CE', 'PASS', 'RUC'];

export default {
  name: 'products',
  data() {
    return {
      docTypes,
      isValidRuc: false,
      loading: false,
      step: 1,
      event: {},
      products: [],
      dataPrint: {},
      modalConfirmNew: false,
      coupon: {
        code: '',
        type: '',
        percentage: 0
      },
      couponCode: '',
      couponError: false,
      couponManual: [],
      payment: {},
      transaction: {
        isInvoice: false,
        address: '',
        socialReason: ''
      },
      user: {
        document: null,
        documentType: 'DNI',
        email: ''
      },
      accessCode: '',
      //alert
      dismissSecs: 5,
      dismissCountDown: 0,
      //filter
      selectCategory: 'all',
      saleType: 'product'
    };
  },
  created() {
    this.getProducts();
    // this.getCouponProducts();
    this.getEventData();
  },
  watch: {
    thereAreProducts(count) {
      if (count == 0) {
        this.removeCoupon();
      }
    }
  },
  computed: {
    taxTotal() {
      return this.dataPrint.voucher.items.reduce((acc, item) => {
        return acc + parseFloat(item.tax);
      }, 0)
    },
    searchProducts() {
      return this.products.filter((elem) => {
        return this.selectCategory != 'all'
          ? elem.category.id.toLowerCase().indexOf(this.selectCategory.toLowerCase()) > -1
          : this.products;
      });
    },
    showLoadingJoinnus() {
      return this.$store.state.loadingJoinnus;
    },
    disabledSearchDocumentType() {
      return this.user.documentType && this.user.document ? false : true;
    },
    isDeliveryProccess() {
      return this.$store.getters.getIsDeliveryProccess;
    },
    isCustomer() {
      return this.$store.getters.isCustomer;
    },
    isIntimo() {
      return this.$store.getters.isIntimo;
    },
    profileIntimo() {
      return this.$store.getters.getProfileIntimo;
    },
    disabledBtnNextStepThree() {
      if (!this.isDeliveryProccess) {
        return !!(
          this.transaction.isInvoice &&
          !this.transaction.socialReason &&
          !this.transaction.address &&
          !this.transaction.document
        );
      } else {
        if (!this.isCustomer) {
          return true;
        } else if (this.isCustomer && this.isHomeDelivery && !this.hasTimeAndDate) {
          return true;
        } else {
          return false;
        }
      }
    },
    cartMeta() {
      return this.$store.getters.cartProductsMeta;
    },
    thereAreProducts() {
      return this.cartMeta.totalProducts > 0 ? true : false;
    },
    discountText() {
      let txt = '';
      const { type, percentage } = this.coupon;
      if (type === 'percentage') {
        txt = `Descuento de ${percentage}%`;
      } else {
        txt = 'Descuento de Promo 3x2';
      }
      return txt;
    },
    couponProducts() {
      return this.$store.state.cart.couponProducts;
    },
    couponFree() {
      const value =
        this.coupon && this.coupon.type === 'percentage' && this.coupon.percentage === 100;
      return !value;
    },
    isInvoice() {
      return this.transaction.isInvoice;
    },
    categories() {
      return this.$store.getters.getCategories;
    }
  },
  methods: {
    registerDataUser(data) {
      this.user = data.user;
      this.buycorporate = data.buycorporate;
      this.participants = data.participants;
      this.goStep(3);
    },
    onSelectCategory(id) {
      this.selectCategory = id;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    autocompleteUser() {
      this.user.email = 'externo@joinnus.com';
      this.user.document = '00000000';
      this.user.documentType = 'DNI';
      this.transaction.isInvoice = false;
    },
    verifyUser(value, type) {
      this.isBilling = false;
      if (type === 'email') {
        const data = {
          filters: [
            {
              field: type,
              value: value
            }
          ]
        };
        this.verifyUserApi(data);
      } else {
        const data = {
          filters: [
            {
              field: 'dniuser',
              value: value
            },
            {
              field: type,
              value: this.user.documentType
            }
          ]
        };
        this.verifyUserApi(data);
      }
    },
    async verifyUserApi(data) {
      try {
        this.$store.dispatch('changeLoadingJoinnus', true);
        const response = await api.verificationUser(data);
        if (response.userExists) {
          this.setDataVerifyUser(response.user);
        } else {
          this.showAlert();
          this.resetForm();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.dispatch('changeLoadingJoinnus', false);
      }
    },
    setDataVerifyUser(payload) {
      this.user.email = payload.email;
      this.user.document = payload.dniUser;
      this.user.documentType = payload.documentType;
    },
    resetForm() {
      this.user.email = '';
      this.user.document = '';
      this.transaction.isInvoice = false;
      this.transaction.address = '';
      this.transaction.socialReason = '';
    },
    validateRuc(value) {
      return value.length === 11 ? false : true;
    },
    goStep(step) {
      this.step = step;
      this.clearInvoice();
    },
    print() {
      window.print();
    },
    newShop() {
      this.getProducts();
      this.goStep(1);
    },
    searchSubmit(q) {
      this.getProducts(q);
    },
    async validateUserIntimo(value) {
      try {
        const body = { filters: [{ field: 'dniUser' ,value: value }] };
        const response = await api.verificationUserIntimo(body);
        this.$store.dispatch('setProfile', response);
      } catch (error) {
        console.log(error);
      }
    },
    setCategoriesProducts(values) {
      const categories = values.map((elem) => elem.category);
      let hash = {};
      const dataArr = categories.filter((elem) => (hash[elem.id] ? false : (hash[elem.id] = true)));
      this.$store.dispatch('setCategories', dataArr);
    },
    async getProducts(q) {
      const { eventId } = this.$route.params;
      // disable all products
      // if (!eventId) return;
      this.loading = true;
      const data = await api.getProducts({ eventId, q });
      this.setCategoriesProducts(data);
      this.products = data;
      this.loading = false;
    },
    async getEventData() {
      const { eventId } = this.$route.params;
      const { eventData } = await api.getDataEvent(eventId);
      this.event = eventData;
    },
    onPay(res) {
      this.goStep(4);
      this.accessCode = res.data.voucher ? res.data.voucher.accessCode : '';
      const cart = [...this.$store.getters.cartProducts];
      this.$store.commit('cleanCartProducts');
      const currency = cart[0].currency.symbol;
      const { voucher } = res.data;

      if (voucher) {
        let method = '';
        let methodCard = '';
        const { methods } = res.data.voucher;

        if (methods.efectivo && methods.pos) {
          method = 'multiple';
          methodCard = methods.pos.cardType;
          voucher.methods.efectivo.amountReturned = voucher.methods.efectivo.amountReturned
            ? voucher.methods.efectivo.amountReturned
            : 0;
        } else {
          if (methods.efectivo && methods.efectivo.paymentMethod) {
            method = methods.efectivo.paymentMethod;
            voucher.methods.efectivo.amountReturned = voucher.methods.efectivo.amountReturned
              ? voucher.methods.efectivo.amountReturned
              : 0;
          }
          if (methods.pos && methods.pos.paymentMethod) {
            method = methods.pos.paymentMethod;
            methodCard = methods.pos.cardType;
          }
          if (methods.qrvisa && methods.qrvisa.paymentMethod) {
            method = methods.qrvisa.paymentMethod;
          }
        }

        const result = Object.keys(voucher.items)
          .map((x) => parseFloat(voucher.items[x].total, 2))
          .reduce((a, b) => a + b);
        voucher.totalAmount = result.toFixed(2);

        const meta = {
          currency,
          method,
          methodCard,
          siteUrl: 'https://www.joinnus.com'
        };

        this.$set(this.dataPrint, 'meta', meta);
        this.$set(this.dataPrint, 'voucher', voucher);

        setTimeout(() => {
          this.print();
        }, 1000);

        if (this.user.email) {
          meta.event = this.event.title;
          const payload = {
            email: this.user.email,
            data: {
              meta,
              voucher
            }
          };
          this.sendEmail(payload);
        }
      }

      this.transaction = {};
      this.transaction.isInvoice = false;
      this.user = {};
      this.user.documentType = 'DNI';
      this.removeCoupon();
    },
    async getCouponProducts() {
      const { eventId } = this.$route.params;
      const data = await api.getCouponProducts(eventId);
      this.couponManual = data.manual;
      data.auto.forEach((item) => {
        if (item.type === '3x2') {
          const date = new Date();
          let applyPromo = false;
          const coupon3x2 = {
            code: item.code,
            type: item.type,
            percentage: 0,
          };
          item.dates.forEach((value) => {
            const dateStart = new Date(value.startDate);
            const dateEnd = new Date(value.endDate);
            if (date >= dateStart && date <= dateEnd) {
              applyPromo = true;
            }
          });
          if (applyPromo) {
            this.$store.commit('updateCouponProducts', {
              type: '3x2',
              value: coupon3x2,
            });
          }
        } else {
          const value = { ...item };
          value.value = value.percentage;
          this.$store.commit('updateCouponProducts', {
            type: 'percentage',
            value,
          });
        }
      });
    },
    verifyCoupon() {
      this.couponError = false;
      this.coupon = {};
      const result = this.couponManual.find(el => el.code.toUpperCase() === this.couponCode.toUpperCase());
      if (result) {
        this.coupon = result;
        if (result.type === 'percentage') {
          this.$store.commit('updateCouponProducts', {
            type: 'full',
            value: this.coupon
          });
        } else if (this.cartMeta.totalProducts >= 3) {
          this.$store.commit('updateCouponProducts', {
            type: '3x2',
            value: this.coupon
          });
        }
      } else {
        this.couponError = true;
        setTimeout(() => {
          this.couponError = false;
          this.couponCode = '';
        }, 7000);
      }
    },
    removeCoupon() {
      this.couponCode = '';
      this.$store.commit('updateCouponProducts', {
        type: this.coupon.type,
        value: ''
      });
      this.coupon = {};
      this.getCouponProducts();
    },
    changeInvoice() {
      if (!this.transaction.isInvoice) {
        this.user.documentType = 'RUC';
      } else {
        this.user.documentType = 'DNI';
      }
    },
    checkedInvoce() {
      if (this.user.documentType === 'RUC') {
        this.transaction.isInvoice = true;
        return true;
      } else {
        this.transaction.isInvoice = false;
        return false;
      }
    },
    acceptNum(event) {
      const key = event.keyCode;
      if (!(key <= 13 || (key >= 48 && key <= 57) || key === 46)) {
        this.user.document = this.user.document.replace(/[^0-9.,]+/, '');
      }
    },
    clearInvoice() {
      if (this.step === 5 && !this.couponFree) {
        this.transaction.isInvoice = false;
        this.user.documentType = 'DNI';
      }

      if (this.step === 2) {
        this.getCouponProducts();
      }
    },
    async sendEmail(payload) {
      await api.sendEmail(payload);
    },
    async isDeliveryProcess() {
      // await this.$store.dispatch('getEvents');
    }
  }
};
</script>
<style lang="scss" scoped>
.card-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ced4da;
  padding-bottom: 1rem;
  margin-bottom: 3rem;
}
.categories {
  padding: 0 2rem;
  background: white;
  margin-bottom: 2rem;
  margin-top: -24px;
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    li {
      padding: 1rem;
      cursor: pointer;
    }
    li:hover {
      font-weight: bold;
    }
    .select {
      font-weight: bold;
    }
  }
}
</style>